export const RACIAL_TRAIT_CHOICE_SET_REQUEST = 'character.RACIAL_TRAIT_CHOICE_SET_REQUEST';
